import { SPRITE_SRC, SPRITE_THUMB, SPRITE_LIBRARY, SPRITE_GROUPS } from "../../data/studioAssets";
import { cn } from "../../lib/utils";

const AVATAR_SRC = SPRITE_THUMB;  // 128px thumbs: a picker full of avatars stays light on tablets
// Same list as the backend (tenant.AVATARS): every sprite except the building blocks, grouped for the picker
export const AVATAR_GROUPS = SPRITE_GROUPS.filter((g) => g !== "blocks").map((g) => [g, SPRITE_LIBRARY.filter((s) => s.group === g).map((s) => s.key)]);
export const AVATARS = AVATAR_GROUPS.flatMap(([, keys]) => keys);

export function AvatarImg({ avatar, size = 44, className }) {
  return (
    <span className={cn("grid place-items-center rounded-full bg-teal-50 border-2 border-teal-100 overflow-hidden shrink-0", className)} style={{ width: size, height: size }}>
      <img src={AVATAR_SRC[avatar] || SPRITE_SRC[avatar] || SPRITE_SRC.owl} alt={avatar} className="object-contain" style={{ width: size * 0.78, height: size * 0.78 }} />
    </span>
  );
}

export function AvatarPicker({ value, onChange }) {
  return (
    <div className="grid grid-cols-6 gap-2 mt-1 max-h-64 overflow-y-auto pe-1" data-testid="avatar-picker">
      {AVATARS.map((a) => (
        <button key={a} type="button" data-testid={`avatar-${a}`} onClick={() => onChange(a)}
          className={cn("rounded-2xl p-1 border-2 transition-all hover:scale-105", value === a ? "border-teal-500 bg-teal-50" : "border-transparent bg-slate-50")}>
          <AvatarImg avatar={a} size={40} className="bg-transparent border-0 mx-auto" />
        </button>
      ))}
    </div>
  );
}
